<template lang="pug">
    div(ref="displayWidget" class="p-3 mt-2 md:my-8")
        div(
            v-if="$searchContext && $parentId"
            class="lg:container"
        )
            div(v-if="$storyblok.isEditing" class="border-b mb-2 space-x-2 uppercase font-bold")
                div(
                    @click="editNoResults = false"
                    class="inline-block py-2 px-4 border border-b-0 rounded-t cursor-pointer"
                    :class="{'text-white bg-info': !editNoResults, 'bg-white': editNoResults }"
                ) Results
                div(
                    @click="editNoResults = true"
                    class="inline-block py-2 px-4 border border-b-0 rounded-t cursor-pointer"
                    :class="{'text-white bg-info': editNoResults, 'bg-white': !editNoResults }"
                ) No Results

            //- We need to hide/show based on editing mode so we opted to not use the noResults comp
            template(v-if="noResults || ($storyblok.isEditing && editNoResults)")
                template(v-if="data.noResultWidgets")
                    template(v-for="widget in data.noResultWidgets")
                        slot(:data="widget")

            SearchResults(v-else :class="{ 'relative': $storyblok.isEditing }")
                template(#results="{ results }")
                    template(v-if="data.widgets")
                        template(v-for="widget in data.widgets")
                            slot(:data="widget")
                    Carousel(v-if="displayMode === 'CAROUSEL'" containerClass="gap-x-3")
                        template(v-for="(result, index) in results" )
                            Article(:article="result" class="w-[275px] md:w-[350px]")

                    template(v-else)
                        div(
                            class="grid gap-6"
                            :class="colsClasses"
                        )
                            template(v-for="(result, index) in results" )
                                Article(:article="result")

                        SearchPagination(v-if="data.showPagination === 'true'" :updateRoute="false" @click.native="scrollToTop" class="mt-6")


                    //- Shade for storyblok editor to prevent clicks
                    div(
                        v-if="$storyblok.isEditing"
                        class="absolute inset-0 z-50"
                    )
        div(v-else-if="$storyblok.isEditing" class="p-2 mb-4 text-sm text-center bg-danger-light border border-danger rounded") Error: The Search Display Widget may only be used inside of a Search Content Wrapper.
</template>

<script>
// Looks like blog page that currently exists
import SearchResults from '@/components/search/results'
import SearchPagination from '@/components/search/pagination'
import Carousel from '@/components/carousel'
import SearchComponent from '@/components/search/component'
import Article from './article'

export default {
    name: 'SearchDisplay',
    components: {
        SearchResults,
        SearchPagination,
        Article,
        Carousel,
    },
    extends: SearchComponent,
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    data() {
        return {
            editNoResults: false,
        }
    },
    computed: {
        /**
         * Tailwind Grid Column Whitelist
         *
         * Because we are dynamically creating the class names to reduce the JS complexity
         * we have to list these classes out so they don't get purged during the build process
         *
         * grid-cols-1 md:grid-cols-1 lg:grid-cols-1
         * grid-cols-2 md:grid-cols-2 lg:grid-cols-2
         * grid-cols-3 md:grid-cols-3 lg:grid-cols-3
         * grid-cols-4 md:grid-cols-4 lg:grid-cols-4
         * grid-cols-5 md:grid-cols-5 lg:grid-cols-5
         * grid-cols-6 md:grid-cols-6 lg:grid-cols-6
         */
        colsClasses() {
            const count = []
            if (this.data.mobileColumnCount)
                count.push(`grid-cols-${this.minMax(this.data.mobileColumnCount)}`)

            if (this.data.tabletColumnCount)
                count.push(`md:grid-cols-${this.minMax(this.data.tabletColumnCount)}`)

            if (this.data.desktopColumnCount)
                count.push(`lg:grid-cols-${this.minMax(this.data.desktopColumnCount)}`)

            return count
        },
        noResults() {
            return this.$searchContext?.state.results.length === 0
        },
        displayMode() {
            const mobileMode =
                this.data.mobileDisplayMode === 'INHERIT' ? 'GRID' : this.data.mobileDisplayMode
            const tabletMode =
                this.data.tabletDisplayMode === 'INHERIT' ? mobileMode : this.data.tabletDisplayMode
            const desktopMode =
                this.data.desktopDisplayMode === 'INHERIT'
                    ? tabletMode
                    : this.data.desktopDisplayMode

            if (this.$device.isMobile) return mobileMode
            else if (this.$device.isDesktop) return desktopMode
            else return tabletMode
        },
    },
    methods: {
        minMax(max) {
            return Math.min(Math.max(max, 1), 6)
        },
        scrollToTop() {
            if (!this.$refs.displayWidget) return
            this.$scrollTo(this.$refs.displayWidget, 500)
        },
    },
}
</script>
